// Burglengenfeld plant code for cypress tests
export const TEST_PLANT_CODE = '0014'
export const TEST_PLANT_UPM_ID = 'a8adbe9b-a48c-83e8-913d-6e35a5d718f8'
export const TEST_CC_PLANT_CODE = 'U118' // Cape Canaveral plant code

export const TEST_USER_ID = 'TEST_USER_ID'
export const TEST_USER_NAME = 'Cypress Test User'

export const MOCK_REQUEST_TIMEOUT_KEY = 'mockRequestTimeout'

export const TEST_KILN_ID = '16ecd9a6-8b7d-8ce1-95b3-0401bfb6657e'
